module.exports = __webpack_public_path__ + "static/media/gmail.0ee01418.jpg";